(function () {
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  function setMenuState(menu, expanded) {
    const toggle = menu.querySelector('[data-footer-menu-toggle]');
    const panel = menu.querySelector('[data-footer-menu-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
  }

  function syncFooter(footer) {
    const wasMobile = footer.getAttribute('data-footer-viewport') === 'mobile';
    footer.querySelectorAll('[data-footer-menu]').forEach(function (menu) {
      if (mobileQuery.matches) {
        const defaultOpen = menu.classList.contains('footer__menu-block--default-open');
        const initialized = menu.hasAttribute('data-footer-menu-initialized');
        const preserveState = initialized && wasMobile;
        const currentOpen = menu.querySelector('[data-footer-menu-toggle]').getAttribute('aria-expanded') === 'true';
        setMenuState(menu, preserveState ? currentOpen : defaultOpen);
        menu.setAttribute('data-footer-menu-initialized', '');
      } else {
        setMenuState(menu, true);
      }
    });
    footer.setAttribute('data-footer-viewport', mobileQuery.matches ? 'mobile' : 'desktop');
  }

  function initFooter(footer) {
    if (!footer || footer.hasAttribute('data-footer-initialized')) return;
    footer.setAttribute('data-footer-initialized', '');
    footer.addEventListener('click', function (event) {
      const toggle = event.target.closest('[data-footer-menu-toggle]');
      if (!toggle || !mobileQuery.matches) return;
      const menu = toggle.closest('[data-footer-menu]');
      setMenuState(menu, toggle.getAttribute('aria-expanded') !== 'true');
    });
    syncFooter(footer);
  }

  function initAllFooters() {
    document.querySelectorAll('[data-footer-section]').forEach(initFooter);
  }

  document.addEventListener('DOMContentLoaded', initAllFooters);
  document.addEventListener('shopify:section:load', function (event) {
    const footer = event.target.matches('[data-footer-section]')
      ? event.target
      : event.target.querySelector('[data-footer-section]');
    initFooter(footer);
  });

  const onBreakpointChange = function () {
    document.querySelectorAll('[data-footer-section]').forEach(syncFooter);
  };
  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', onBreakpointChange);
  } else {
    mobileQuery.addListener(onBreakpointChange);
  }
})();
